import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { SliderFormControlComponent } from './slider-form-control.component';



@NgModule({
  declarations: [
    SliderFormControlComponent
  ],
  exports: [
    SliderFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormControlsUtilsModule,
    MatSlideToggleModule
  ]
})
export class SliderFormControlModule { }
